import { render, staticRenderFns } from "./report_content_item.vue?vue&type=template&id=512a5b8a&scoped=true&"
import script from "./report_content_item.vue?vue&type=script&lang=js&"
export * from "./report_content_item.vue?vue&type=script&lang=js&"
import style0 from "./report_content_item.vue?vue&type=style&index=0&id=512a5b8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512a5b8a",
  null
  
)

export default component.exports